import {
  EditViewType,
  NewViewType
} from '@nile/mangifera/src/Containers/PageContainers';
import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

function ViewIndexPage({ match }) {
  const { pagename: type } = match.params;
  return (
    <Wrapper className="white-grey-page">
      {type === 'new' && <NewViewType />}
      {type === 'edit' && <EditViewType />}
    </Wrapper>
  );
}
const Wrapper = styled.div`
  height: calc(100vh - 150px);
  max-width: 1400px;
  margin: 40px auto;
`;

export default withRouter(ViewIndexPage);
